import { render, staticRenderFns } from "./VxLoader.vue?vue&type=template&id=12073a34"
import script from "./VxLoader.vue?vue&type=script&lang=js"
export * from "./VxLoader.vue?vue&type=script&lang=js"
import style0 from "./VxLoader.vue?vue&type=style&index=0&id=12073a34&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports